import { ReceivedDocumentStatusEnum } from '../../HealthClaimPage/ClaimHandlingTable/types'
import ConfirmReceiveDocumentModal from '../ConfirmReceiveDocumentModal/ConfirmReceiveDocumentModal'
import CancelDocumentRequestModal from '../CancelDocumentRequestModal'
import SupportingDocumentsForClaimTabDocument from '../SupportingDocumentsForClaimTabDocument/SupportingDocumentsForClaimTabDocument'
import SupportingDocumentsForClaimTabHistory from '../SupportingDocumentsForClaimTabHistory/SupportingDocumentsForClaimTabHistory'
import SupportingDocumentsForClaimTabOriginalDocument from '../SupportingDocumentsForClaimTabOriginalDocument/SupportingDocumentsForClaimTabOriginalDocument'
import SupportingDocumentsModal from '../SupportingDocumentsModal/SupportingDocumentsModal'
import SupportingDocumentsForClaimHook from './SupportingDocumentsForClaim.hook'
import { ButtonDocument, ButtonWrapper, Container, ContainerTitle, Tabs, Title } from './styles'
import { Space, TabsProps } from 'antd'

const SupportingDocumentsForClaim = () => {
  const {
    isModalOpen,
    handleClickDocument,
    handleModalOk,
    handleModalCancel,
    handleOpenModalWithRecord,
    selectedRecord,
    isPending,
    handleDownLoadAll,
    isCreateOrEditMode,
    isEnableDownloadAll,
    isDocumentsRequestedStatus,
    handleConfirmReceive,
    isConfirmReceivePending,
    isConfirmReceiveModalOpen,
    handleConfirmReceiveModalClose,
    handleConfirmReceiveModalConfirm,
    isCancelRequestModalOpen,
    isCancelRequestPending,
    handleCancelRequestModalClose,
    handleCancelRequestModalConfirm,
    receivedDocumentStatus,
    statusDisplayReceivedTabs,
    currentActiveTab,
    handleTabClick,
    canReceivedDocument,
    triggerBulkFilePicker,
    handleBulkFileChange,
    bulkFileInputRef,
    isBulkUploadPending,
    bulkUploadProgress,
  } = SupportingDocumentsForClaimHook()

  const tabItems: TabsProps['items'] = [
    {
      key: '1',
      label: 'รายการเอกสาร',
      children: <SupportingDocumentsForClaimTabDocument />,
    },
    {
      key: '2',
      label: 'ประวัติขอเอกสารเพิ่มเติม',
      children: <SupportingDocumentsForClaimTabHistory onModalOpen={handleOpenModalWithRecord} />,
    },
  ]

  if (statusDisplayReceivedTabs.includes(receivedDocumentStatus)) {
    tabItems.push({
      key: '3',
      label: 'การรับเอกสารฉบับจริง',
      children: <SupportingDocumentsForClaimTabOriginalDocument />,
    })
  }

  return (
    <Container>
      <ContainerTitle>
        <Title>เอกสารประกอบการพิจารณา</Title>
        <ButtonWrapper>
          <Space>
            {isCreateOrEditMode && (
              <>
                <ButtonDocument onClick={triggerBulkFilePicker} loading={isBulkUploadPending}>
                  {isBulkUploadPending
                    ? `กำลังอัปโหลด ${bulkUploadProgress}%`
                    : 'อัปโหลดเอกสารเป็นชุดเดียว'}
                </ButtonDocument>
                <input
                  type="file"
                  accept="image/*,application/pdf,.pdf"
                  ref={bulkFileInputRef}
                  onChange={handleBulkFileChange}
                  style={{ display: 'none' }}
                />
              </>
            )}
            {canReceivedDocument &&
              receivedDocumentStatus === ReceivedDocumentStatusEnum.NOT_RECEIVED && (
                <ButtonDocument onClick={handleConfirmReceive} loading={isConfirmReceivePending}>
                  ยืนยันรับเอกสารฉบับจริง
                </ButtonDocument>
              )}
            {isCreateOrEditMode && (
              <ButtonDocument
                onClick={() => handleClickDocument()}
                disabled={isDocumentsRequestedStatus}
              >
                ขอเอกสารเพิ่มเติม
              </ButtonDocument>
            )}
          </Space>

          {isEnableDownloadAll && (
            <ButtonDocument loading={isPending} onClick={handleDownLoadAll}>
              ดาวน์โหลดรูปทั้งหมด
            </ButtonDocument>
          )}
        </ButtonWrapper>
      </ContainerTitle>
      <Tabs items={tabItems} activeKey={currentActiveTab} onTabClick={handleTabClick} />
      <SupportingDocumentsModal
        isModalOpen={isModalOpen}
        handleOk={handleModalOk}
        handleCancel={handleModalCancel}
        selectedRecord={selectedRecord}
      />
      <ConfirmReceiveDocumentModal
        centered={true}
        isModalOpen={isConfirmReceiveModalOpen}
        onClose={handleConfirmReceiveModalClose}
        onConfirm={handleConfirmReceiveModalConfirm}
        isLoading={isConfirmReceivePending}
      />
      <CancelDocumentRequestModal
        centered={true}
        isModalOpen={isCancelRequestModalOpen}
        onClose={handleCancelRequestModalClose}
        onConfirm={handleCancelRequestModalConfirm}
        isLoading={isCancelRequestPending}
      />
    </Container>
  )
}

export default SupportingDocumentsForClaim
